import React, {useCallback, useState} from 'react'
import styled from 'styled-components'
import {Paragraph, ToggleSwitch} from 'common/components'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const StyledSettingItemContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`

export default function DropboxUploadInfoSettings({
  onToggleCompress,
}: {
  onToggleCompress: (toggle: boolean) => void
}) {
  const [compress, setCompress] = useState(true)

  const handleSwitch = useCallback(
    () =>
      setCompress((prev) => {
        onToggleCompress(!prev)
        return !prev
      }),
    [onToggleCompress],
  )

  return (
    <StyledContainer>
      <Paragraph fontWeight="bold" color="gray_5">
        Upload Settings
      </Paragraph>
      <StyledSettingItemContainer>
        <div>
          <Paragraph fontSize="m" fontWeight="medium">
            Compress Photo
          </Paragraph>
          <Paragraph color="gray_5">(Compressed Result is 2 MB)</Paragraph>
        </div>
        <ToggleSwitch selected={compress} onSwitch={handleSwitch} />
      </StyledSettingItemContainer>
    </StyledContainer>
  )
}
